// Import React.
import React from "react";



// Export an individual policy section.
export const PolicySection = ({
    policy,
}) => {

    // Return nothing when there is no policy section.
    if (!policy) {

        // Prevent an empty section being rendered.
        return null;

    }



    // Render the policy section.
    return (

        // Give the section the API section key so navigation can target it.
        <section
            className="policy-section"
            id={policy?.section_key}
        >

            {/* Render the policy HTML supplied by the API. */}
            <div
                className="policy-section__body"
                dangerouslySetInnerHTML={{
                    __html: policy?.body ?? "",
                }}
            />

        </section>

    );

};